const isDev = process.env.NODE_ENV === "development";

/** Logs solo en desarrollo; evita filtrar URLs con PII, tokens o payloads en producción. */
export function devLog(...args) {
  if (isDev) console.log(...args);
}

export function devWarn(...args) {
  if (isDev) console.warn(...args);
}
